import React from "react";

interface TextFieldProps {
  id?: string;
  type: string;
  name?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  leadingIcon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  min?: string;
  max?: string;
  maxLength?: number;
}

const TextField: React.FC<TextFieldProps> = ({
  id,
  type,
  name,
  value,
  onChange,
  placeholder,
  leadingIcon,
  trailingIcon,
  className = "",
  disabled = false,
  min,
  max,
  maxLength,
}) => {
  if (leadingIcon || trailingIcon) {
    return (
      <div className={`relative ${className}`}>
        {leadingIcon && (
          <div className="absolute left-3 top-5 mt-0.5 transform -translate-y-1/2 pointer-events-none">
            {leadingIcon}
          </div>
        )}
        <input
          id={id}
          type={type}
          name={name}
          value={value ?? ""}
          onChange={onChange}
          placeholder={placeholder}
          className={`${leadingIcon ? "pl-10" : "pl-3"} ${
            trailingIcon ? "pr-10" : "pr-3"
          } w-full py-2.5 placeholder-gray-400 border border-[#C72BA4] hover:border-[#EA33C0] focus:ring-[#C72BA4] focus:border-[1.5px] rounded-lg focus:outline-none transition duration-200 placeholder:text-sm text-sm`}
          disabled={disabled}
          min={min}
          max={max}
          maxLength={maxLength}
        />
        {trailingIcon && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            {trailingIcon}
          </div>
        )}
      </div>
    );
  }

  return (
    <input
      id={id}
      type={type}
      name={name}
      value={value ?? ""}
      onChange={onChange}
      placeholder={placeholder}
      className={
        "px-3 py-2.5 border border-[#C72BA4] hover:border-[#EA33C0] focus:ring-[#C72BA4] focus:border-[1.5px] rounded-lg focus:outline-none transition duration-200 placeholder:text-sm text-sm disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed " +
        className
      }
      disabled={disabled}
      min={min}
      max={max}
      maxLength={maxLength}
    />
  );
};

export default TextField;
